import Swiper from 'swiper';
import {Navigation, Pagination, Thumbs} from "swiper/modules";
import {Fancybox} from "@fancyapps/ui";
import 'swiper/scss';
import '@fancyapps/ui/src/Fancybox/Fancybox.scss';
import {
    Collapse,
    Carousel,
    initTWE,
    Modal,
    Tab,
} from "tw-elements";

initTWE({Collapse, Carousel, Modal, Tab});

Swiper.use([Navigation, Pagination, Thumbs]);

const thumbnailSwiper = new Swiper('.thumbnailSwiper', {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
});

const swiper = new Swiper('.product-images-swiper', {
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: ".swiper-pagination",
    },
    thumbs: {
        swiper: thumbnailSwiper,
    },
});

new Swiper('.upSellSwiper', {
    spaceBetween: 20,
    slidesPerView: 1.25,
    freeMode: true,
    breakpoints: {
        768: {
            slidesPerView: 4,

        },
    },
});

Fancybox.bind('.product-images .swiper-slide img', {
    groupAll: true
});

jQuery('.product-thumbs [data-thumb] a').click(function (e) {
    e.preventDefault();

    swiper.slideTo(jQuery(this).closest('[data-thumb]').index());
})

jQuery('.variations_form.cart').on('found_variation', function (e, variation) {
    const productCalculator = jQuery('[data-product-calculator]');

    productCalculator.data('priceExcl', variation.price_excl);
    productCalculator.data('priceIncl', variation.display_price);
})

jQuery('[data-image-zoom]').click(function (e) {
    e.preventDefault()
    jQuery('.swiper-slide.swiper-slide-active img').click();
})

jQuery(document).ready(function ($) {
    // Copy from product-price.js we need to make this public
    function removeErrorMessages(element = null) {
        if (element) {
            element.find('.invalid-message').remove();
        } else {
            $('.invalid-message').remove();
        }
    }

    function updateURLWithSelectedOptions() {
        $('.product-option-check').on('change', function () {
            var currentURL = new URL(window.location.href);

            $('.product-option-check:checked').each(function () {
                var optionName = $(this).attr('name');
                var selectedValue = $(this).val();
                currentURL.searchParams.set(optionName, selectedValue);
            });

            history.pushState(null, '', currentURL);
        });
    }

    function setRadioButtonsFromURL() {
        var currentURL = new URL(window.location.href);

        currentURL.searchParams.forEach(function (value, key) {
            // Reset initial value to prevent strange behavior
            $('.product-option-check[name="' + key + '"]').prop('checked', false);

            // Set the correct value to active
            $('.product-option-check[name="' + key + '"][value="' + value + '"]').prop('checked', true);
        });
    }

    function updateProductOptionButtonsFromURL() {
        var optionName = $(this).attr('name');
        var selectedValue = $(this).val();
        $('.iconic-wlv-terms__term-content').each(function () {
            var href = $(this).attr('href');
            if (href) {
                var newURL = new URL(href, window.location.origin);
                newURL.searchParams.set(optionName, selectedValue);
                $(this).attr('href', newURL.toString());
            }
        });
    }

    setRadioButtonsFromURL();
    updateURLWithSelectedOptions();
    updateProductOptionButtonsFromURL();

    function updateURLWithInputValues() {
        var lengthValue = $('#product_1_length').val();
        var widthValue = $('#product_1_width').val();

        var currentURL = new URL(window.location.href);
        currentURL.searchParams.set('lengte', lengthValue);
        currentURL.searchParams.set('breedte', widthValue);

        history.pushState(null, '', currentURL);
    }

    function updateLinksWithInputValues() {
        var lengthValue = $('#product_1_length').val();
        var widthValue = $('#product_1_width').val();

        $('.iconic-wlv-terms__term-content').each(function () {
            var href = $(this).attr('href');
            if (href) {
                var newURL = new URL(href, window.location.origin);
                newURL.searchParams.set('lengte', lengthValue);
                newURL.searchParams.set('breedte', widthValue);
                $(this).attr('href', newURL.toString());
            }
        });
    }

    $('#product_1_length, #product_1_width').on('input', function () {
        updateURLWithInputValues();
        updateLinksWithInputValues();
    });

    updateLinksWithInputValues();

    function updateProductOptionValue() {
        $('.form-row[data-option-type]').each(function(){
            const type = $(this).data('option-type');
            const productOptionsRow = $(this).closest('.product-options-row');
            const currentValueHolder = productOptionsRow.find('[data-current-value]');
            let currentValue = '';
            let finished = false;

            switch (type) {
                case 'radio':
                    const activeElement = $(this).find('input[type="radio"]:checked');

                    if (activeElement.length) {
                        currentValue = activeElement.data('checked-value');
                        finished = true;
                    }
                    break;
                case 'measurement':
                    const activeTextElement = $(this).find('input[type="measurement"]');

                    if (activeTextElement.length) {
                        currentValue = activeTextElement.data('checked-value');
                        finished = true;
                    }
                    break;
            }

            if (currentValue.length > 0) {
                currentValue = '(' + currentValue + ')';
            }

            currentValueHolder.html(currentValue);
            productOptionsRow.find('[data-option-finished]').attr('data-option-finished', finished);
            productOptionsRow.find('.circle-option').toggleClass('circle-option-check', finished);
        });
    }

    function checkAndSetDimensions() {
        const row = $('[data-dimension-field]');
        const productOptionsRow = row.closest('.product-options-row');
        const currentValueHolder = productOptionsRow.find('[data-current-value]');
        const lengthElement = row.find('[data-product-length]');
        const widthElement = row.find('[data-product-width]');

        let currentValue = '';
        let finished = false;

        if (lengthElement.val() && widthElement.val()) {
            const length = convertUnitValue(
                    lengthElement.val(),
                    lengthElement.data('inputUnit'),
                    'mm',
                );

            const width = convertUnitValue(
                    widthElement.val(),
                    widthElement.data('inputUnit'),
                    'mm',
                );

            currentValue = ' (' + length + 'mm x ' + width + 'mm)';

            finished = lengthElement.data('is-valid') && widthElement.data('is-valid');
        }

        currentValueHolder.html(currentValue);
        productOptionsRow.find('[data-option-finished]').attr('data-option-finished', finished);
        productOptionsRow.find('.circle-option').toggleClass('circle-option-check', finished);
    }

    checkAndSetDimensions();
    updateProductOptionValue();

    $(document)
        .on('change keyup', '#product_1_length, #product_1_width', function(){
            checkAndSetDimensions();
        })
        .on('change', '[data-product-calculator] [data-option-type] input', function() {
            updateProductOptionValue();
        })
        .on('change', '[data-option-type="productSell"] input[type=number]', function(e){
            const holder = $(this).closest('.quantity');

            holder.find('[data-upsize-quantity="min"]').prop('disabled', $(this).val() < 1);

            $(this).closest('[data-option-type="productSell"]').toggleClass('selected', $(this).val() > 0);
        })
        .on('click', '[data-upsize-quantity]', function (e) {
            e.preventDefault();

            const referencedQuantityField = $(this).closest('.quantity').find('input[type=number]');
            let quantity = parseInt(referencedQuantityField.val(), 10)

            if ($(this).data('upsize-quantity') === 'plus') {
                quantity += 1;
            } else {
                quantity -= 1;
            }

            if (quantity < 0) {
                quantity = 0;
            }

            referencedQuantityField.val(quantity).change();
        })
        .on('click', '[data-reset-product-options]', function(e){
            e.preventDefault();

            let productCalculator = $(this).closest('[data-product-calculator]');
            if (!productCalculator.length) {
                productCalculator = $('[data-product-calculator]');
            }
            const quantityField = productCalculator.find('[data-totals] .qty');

            productCalculator.find('[data-option-type]').each(function(){
                const type = $(this).data('option-type');

                switch (type) {
                    case 'radio':
                        $(this).find('input[type="radio"]').each(function(){
                            $(this).prop('checked', $(this).data('default-value'));
                        })
                        break;
                    default:
                        $(this).val('');
                        break;
                }
            });

            productCalculator.find('[data-dimension-field]').each(function(){
                $('[data-product-length], [data-product-width]').val('');
            });

            updateProductOptionValue();
            checkAndSetDimensions();
            updateURLWithInputValues();

            // Reset quantity to min value
            quantityField.val(quantityField.attr('min')).change();

            // Since this is a reset we do not need validation messages
            removeErrorMessages(productCalculator);

            // Show first toggle again
            const collapseElement = $($('[data-twe-target][data-option-finished="false"]:first').data('twe-target'));

            if (typeof collapseElement.attr('data-twe-collapse-show') === 'undefined') {
                const collapse = new Collapse(collapseElement.get(0));

                collapse.show();
            }
        })
    ;

    const extraContentModalElement = document.getElementById("extraContentModal");
    if (extraContentModalElement) {
        extraContentModalElement.addEventListener("show.twe.modal", (e) => {
            const triggerButton = e.relatedTarget;
            const extraContent = triggerButton.getAttribute('data-extra-content');
            const modalBody = extraContentModalElement.querySelector("[data-twe-modal-body-ref]");
            modalBody.innerHTML = extraContent;
        });
    }
});